/**
 * QZ Tray 打印服务客户端
 *
 * QZ Tray 是开源免费的本地打印服务（需安装 Java）。
 * 前端通过 WebSocket 连接本地 QZ Tray 服务，实现静默打印。
 *
 * 下载安装: https://qz.io/download/
 * 需要环境: Java 8+
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import qz from 'qz-tray';
import forge from 'node-forge';

// 终端实体证书（由自有 CA 签发，CA 证书通过 override.crt 部署到 QZ Tray）
const CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIDCTCCAfGgAwIBAgIULqfJi1mIpuNm1eewMFvCghZa65MwDQYJKoZIhvcNAQEL
BQAwHjEcMBoGA1UEAwwTU3dpZnRYIFdNUyBQcmludCBDQTAeFw0yNjA0MTAwNzIw
NTRaFw0zNjA0MDcwNzIwNTRaMBsxGTAXBgNVBAMMEFN3aWZ0WCBXTVMgUHJpbnQw
ggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQC4lnQ7Hz6fQ4qRYd0/F/Cb
EoqLzCdWv775QHRFPeIen38aqlHEGeEFBOGRWFLaWqNZO4ItZv096NipZkwCGYKp
zI/QV9hBh2xIXt49CSgKcKGXqNcdMC1tm7R3ZelUNfYlBdB88mkWS1L+HW11VkDs
bRoHD55et5WLxIBT6399zBd+oGZhLWhe7WmR7bu943ZPog7sG2LDafBg92uzxc1N
CKhdF8Y3Z7DILc1bzry7FbRVZyGh6Ty+yuMu4lW7oBzQaq1TIgtfwBV4j6MI3dIM
KiLPhd5AvSiIqDBfwiqdpLmwYYRbH2H2r/zqd/GJiNFPllNqlw+f3sVdBQe64gVR
AgMBAAGjQjBAMB0GA1UdDgQWBBQoJFlSn8DFf3PGn85BDStkZQEvYzAfBgNVHSME
GDAWgBSuyLv5wGLbKa2bIr09/JUdLacJ+jANBgkqhkiG9w0BAQsFAAOCAQEAcTqy
9Fr5etNSiJmk+DtSRGQM6ifx+QNnIeRIF6hJ3gxiWSRdJb/BCru8b90Bd0TWUflS
cHdG4LEbi4qB7DwVkf+12GPofiE3UCbHWxwQ1ZPhw2RB/ivSo1AokQJvm7Skm8s6
Sg5DB29G8Xphp0tjhI26GG08eQeEdMYqpk7oRQdrt9NQGizd84WA4xQk7yUjvXvr
PU42AHWJ+ZPp1Hgl2B2m1mX2IY6J0EhKXb2OsqyEfo2m+y1q19PxqNKsW7xcbAxb
BPW//pEW47O4KXXVVQ6zyFEm/puhVbqPheCf0KN6Y9Bm3PTD06UX86OXzK46davV
j1SK6TJJTW5Dwrk5vA==
-----END CERTIFICATE-----`;

// 终端实体私钥（用于签名请求）
const PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC4lnQ7Hz6fQ4qR
Yd0/F/CbEoqLzCdWv775QHRFPeIen38aqlHEGeEFBOGRWFLaWqNZO4ItZv096Nip
ZkwCGYKpzI/QV9hBh2xIXt49CSgKcKGXqNcdMC1tm7R3ZelUNfYlBdB88mkWS1L+
HW11VkDsbRoHD55et5WLxIBT6399zBd+oGZhLWhe7WmR7bu943ZPog7sG2LDafBg
92uzxc1NCKhdF8Y3Z7DILc1bzry7FbRVZyGh6Ty+yuMu4lW7oBzQaq1TIgtfwBV4
j6MI3dIMKiLPhd5AvSiIqDBfwiqdpLmwYYRbH2H2r/zqd/GJiNFPllNqlw+f3sVd
BQe64gVRAgMBAAECggEABIXck5BImAgZzpslG9p/JkWWMyZi9mCyEhMZZj2bG0tR
hs/n5f6zq/b6fKBl6KdyO4mrlGeNdVANyFoogEqrZXQM4rrW99q/dVHXGeFuDjzD
8N6Nus+HOsQnGrUwD5oCOIEDzUlL+Dm17w0TNV382ZjeG5CEkxHmLlZicJajeUEV
e3Tj93mMXYnzQfjXLokrbFM0HdqSEnfbkNJQqFtzZTm2xReIKsJRr5b9Zc3dnIRH
NbIdg0sRS2bH9072iglTnoKQUXsPfKI+mOlnrP1odR/AvIx2kM4LP8+2OHqdBDCy
gHOFZpftC9hdYVH6zZBCahAukTYhi1pds/ev+3h9mwKBgQDc0L+NucCdGeKEcljA
SP4pv6kdKeUqSFNH5gvwTZqvGl2eoxvVxVaSI7Ehkae8QGNLChRuqJV9KOp4cx8H
w9IXd7mJctO324Ufx8PZVUEHs8Vj0v835pDMtg1slDqkpvJtYoQLSsPY5kEbcOAj
tl0HfRQuwKqNf9RX0QfNLgR+0wKBgQDV//I1Z3FIgX3eTqyvP2GZYGRtspXiOqQw
pftfw/7kYWnc7yfDww3H2oB/xQ/mTNrk5q2PppNy4iV+MeCAov0hgolrSenlx2Nx
G+YGYJGIgA4mlk6EJAh7F4GZHr7y2fePvb80+UvIp9eOcQG32EMzLFoih1MvtUwt
4rQyQwg8ywKBgFExqN3SKZMay4HsEdpSfLKZOPPyTcOoaIcNfeJUhsZQKZCFZVzL
fTOrUByJ1GWSP3B+OlkeQCmPe/fiTMysInpimaSCxnraiy7OY6Nsh8bvQWudUB8b
9q5vWqxMLOwSPx4dlXQZf74nnFUcwi4fhkGUqnEugwgYstm/kODPRPPlAoGAVMO/
xcWGiqi4GaFiJzxcxWr3/LebRPPja12jl0hEI2QukZOtVY5iXAJBmdqNtLRGlBqH
LvpVN1E6dqT8/xcQWwCgu/2YBysWSYw6bdY8bywB7ujkitTXAyLJc8RI8FrEA4yu
OyZwDTfmWwaKHq8r1w4/WaPuoFwYo6hDphEFJ0cCgYBJZoS0zPvUkGhKPd7NMj3P
GaNBTN7sw/znGW+lRV/Q4XeEagkg2h2vfEUG51VaOvOHGsXU5PD3iR4tM6gzhssd
/8JVQdW2EvsJrDlG7T3Jjie9Sv9A19jOEeF37z9SejsT8zwXWcGkHIGIpFvqVJOu
s8e5jRJKnVm6s0RmTNxtEw==
-----END PRIVATE KEY-----`;

let securitySetup = false;

// 缓存打印机信息，避免重复调用 QZ API
let cachedPrinters: string[] = [];
let cachedDefaultPrinter = '';

function setupSecurity() {
    if (securitySetup) return;

    qz.security.setCertificatePromise((resolve: any) => {
        resolve(CERTIFICATE);
    });

    qz.security.setSignaturePromise((toSign: any) => (resolve: any, reject: any) => {
        try {
            const privateKey = forge.pki.privateKeyFromPem(PRIVATE_KEY);
            const md = forge.md.sha1.create();
            md.update(toSign, 'utf8');
            const signature = privateKey.sign(md);
            resolve(forge.util.encode64(signature));
        } catch (e) {
            console.error('[QZ Tray] Signing error:', e);
            reject(e);
        }
    });

    securitySetup = true;
}

async function ensureConnected(): Promise<void> {
    setupSecurity();
    if (qz.websocket.isActive()) return;

    try {
        // 超时检测：QZ Tray 运行但证书未部署时，连接会挂起等待用户点弹窗
        await Promise.race([
            qz.websocket.connect(),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('QZ_CERT_SETUP_NEEDED')), 5000)
            ),
        ]);
    } catch (e: any) {
        if (e?.message?.includes('already') && qz.websocket.isActive()) return;
        throw e;
    }
}

/**
 * 检查 QZ Tray 是否可用（只建立连接，不调其他 API，避免弹窗）
 */
export const checkPrintService = async (): Promise<{
    ready: boolean;
    needsCertSetup: boolean;
    printers: string[];
    defaultPrinter: string;
}> => {
    try {
        await ensureConnected();
        return {
            ready: true,
            needsCertSetup: false,
            printers: cachedPrinters,
            defaultPrinter: cachedDefaultPrinter,
        };
    } catch (e: any) {
        console.error('[QZ Tray] Error:', e);
        // 超时 = QZ Tray 运行中但证书未部署（弹窗阻塞了连接）
        const needsCertSetup = e?.message === 'QZ_CERT_SETUP_NEEDED';
        return { ready: false, needsCertSetup, printers: [], defaultPrinter: '' };
    }
};

/**
 * 获取完整打印机列表（打开设置时调用）
 */
export const listPrinters = async (): Promise<string[]> => {
    try {
        await ensureConnected();
        const printers = await qz.printers.find() as string | string[];
        cachedPrinters = Array.isArray(printers) ? printers : [printers];
        return cachedPrinters;
    } catch (e) {
        console.error('[QZ Tray] listPrinters error:', e);
        return cachedPrinters;
    }
};

export interface PrintOptions {
    printer?: string;
    copies?: number;
}

/**
 * 静默打印 Base64 PDF（printer 必传，避免额外 API 调用）
 */
export const qzPrintPdf = async (
    pdfBase64: string,
    options?: PrintOptions,
): Promise<void> => {
    await ensureConnected();

    // 优先用传入的打印机，其次用缓存的，最后才调 API 获取
    let printer = options?.printer || cachedDefaultPrinter;
    if (!printer) {
        cachedDefaultPrinter = await qz.printers.getDefault() as string;
        printer = cachedDefaultPrinter;
    }
    if (!printer) {
        throw new Error('No printer specified');
    }

    const config = qz.configs.create(printer, {
        size: { width: 4, height: 6 },
        units: 'in',
        scaleContent: true,
        copies: options?.copies || 1,
    });

    const data = [{
        type: 'pixel',
        format: 'pdf',
        flavor: 'base64',
        data: pdfBase64,
    }];

    await qz.print(config, data);
};
